// Dispara o anúncio em tela cheia a cada 2 lançamentos criados.
// Usa um evento global em vez de um estado em contexto porque o formulário de lançamento é
// renderizado em mais de um lugar (FAB do layout e a página de Lançamentos) e precisa avisar
// o AppLayout, que é quem efetivamente mostra o anúncio por cima de qualquer página.
const EVENT_NAME = "cn:show-interstitial-ad";
const STORAGE_KEY = "cn_txn_count_since_interstitial";
const EVERY_N = 2;

function readCount(): number {
  const raw = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
  const n = raw ? parseInt(raw, 10) : 0;
  return Number.isFinite(n) ? n : 0;
}

function writeCount(n: number) {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(n));
  } catch {
    // localStorage indisponível — sem problema, só perde a persistência da contagem.
  }
}

/** Chame após criar um lançamento novo (não edição). Dispara o anúncio a cada 2ª chamada. */
export function notifyTransactionCreated(isPremium: boolean) {
  if (isPremium) return;
  const count = readCount() + 1;
  if (count >= EVERY_N) {
    writeCount(0);
    // Pequeno atraso pra deixar a animação de fechar do modal de lançamento terminar antes
    // do anúncio em tela cheia entrar.
    setTimeout(() => window.dispatchEvent(new Event(EVENT_NAME)), 350);
  } else {
    writeCount(count);
  }
}

export function onShowInterstitialAd(handler: () => void) {
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
